import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    skillAcquisitionProgramActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_SKILLACQUISITIONPROGRAM_LIST_API, 
    POST_SKILLACQUISITIONPROGRAM_API, 
    DELETE_SKILLACQUISITIONPROGRAM_API,
    GET_SKILLACQUISITIONPROGRAM_DETAIL_API,
    POST_SKILLACQUISITIONPROGRAMFROMLIBRARY_API,
    PROGRAM_STATUS_ACTIVATION,
    PATCH_PROGRAM_INSTRUCTION,
    GET_MASTER_CURRICULAM_LIBRARIES_API,
    GET_MASTER_DOMIANS_BY_LIBRARY_API,
    GET_MASTER_PROGRAMS_BY_DOMAIN_API,
    POST_COPYPATIENTSKILLACQUISITIONPROGRAM_API,
    GET_GETPATIENTSKILLACQUISITIONPROGRAMSINGLEGRAPH_API,
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import {checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../../actions/utilAction';

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
}; 

export const getSkillAcquisitionProgramList = (searchObj, patientId, skillsAcquisitionDomainId) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONPROGRAM_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionProgramList', error);
            });
    };
};

export const getSkillAcquisitionProgramListDetails = (programId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramDetail.REQUEST));
        fetch(`${GET_SKILLACQUISITIONPROGRAM_DETAIL_API}?programId=${programId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionProgramDetail', error);
            });
    };
};

export const saveSkillAcquisitionProgram = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_skillAcquisitionProgram.REQUEST));
        fetch(`${POST_SKILLACQUISITIONPROGRAM_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_skillAcquisitionProgram.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_skillAcquisitionProgram.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_skillAcquisitionProgram', error);
            });
    };
};


export const saveSkillAcquisitionProgramFromLibrary = (formProps, patientId, domainId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_skillAcquisitionProgramFromLibrary.REQUEST));
        fetch(`${POST_SKILLACQUISITIONPROGRAMFROMLIBRARY_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_skillAcquisitionProgramFromLibrary.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText: null },
                        pageNumber: 1,
                    };                    
                    dispatch(getSkillAcquisitionProgramList(searchObj, patientId, domainId));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_skillAcquisitionProgramFromLibrary.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_skillAcquisitionProgramFromLibrary', error);
            });
    };
};


export const deleteSkillAcquisitionProgram = (programId, patientId, domainId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.delete_skillAcquisitionProgram.REQUEST));
        fetch(`${DELETE_SKILLACQUISITIONPROGRAM_API}?programId=${programId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.delete_skillAcquisitionProgram.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText: null },
                        pageNumber: 1,
                    };                    
                    dispatch(getSkillAcquisitionProgramList(searchObj, patientId, domainId));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.delete_skillAcquisitionProgram.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.delete_skillAcquisitionProgram.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_skillAcquisitionProgram', error);
            });
    };
};

export const updateProgramActiveStatus = (skillsAcquisitionProgramId, IsActivate) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionProgramActionTypes.program_active_status.REQUEST));
      fetch(`${PROGRAM_STATUS_ACTIVATION}?skillsAcquisitionProgramId=${skillsAcquisitionProgramId}&isActive=${IsActivate}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionProgramActionTypes.program_active_status.SUCCESS, response));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionProgramActionTypes.program_active_status.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionProgramActionTypes.program_active_status.SUCCESS, {}));
        });
    };
  };


  export const updateProgramInstruction = (skillsAcquisitionProgramId, programInstruction) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionProgramActionTypes.patch_program_instruction.REQUEST));
      fetch(`${PATCH_PROGRAM_INSTRUCTION}?skillsAcquisitionProgramId=${skillsAcquisitionProgramId}&programInstruction=${programInstruction}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionProgramActionTypes.patch_program_instruction.SUCCESS, response));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionProgramActionTypes.patch_program_instruction.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionProgramActionTypes.program_active_status.SUCCESS, {}));
        });
    };
  };


export const getMasterCurriculumLibraries = () => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterCurriculumLibraries.REQUEST));
        fetch(`${GET_MASTER_CURRICULAM_LIBRARIES_API}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterCurriculumLibraries.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterCurriculumLibraries.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_masterCurriculumLibraries', error);
            });
    };
};


export const getMasterDomainsByLibray = (libraryId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterDomainsByLibrary.REQUEST));
        fetch(`${GET_MASTER_DOMIANS_BY_LIBRARY_API}?libraryId=${libraryId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterDomainsByLibrary.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterDomainsByLibrary.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_masterDomainsByLibrary', error);
            });
    };
};

export const getMasterLibrayByDomain = (domainId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterprogramByDomain.REQUEST));
        fetch(`${GET_MASTER_PROGRAMS_BY_DOMAIN_API}?domainId=${domainId}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterprogramByDomain.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_masterprogramByDomain.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_masterprogramByDomain', error);
            });
    };
};


export const copyPatientSkillAcquisitionProgram = (formProps, patientId, domainId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_copyPatientSkillAcquisitionProgram.REQUEST));
        fetch(`${POST_COPYPATIENTSKILLACQUISITIONPROGRAM_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_copyPatientSkillAcquisitionProgram.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText: null },
                        pageNumber: 1,
                    };                    
                    dispatch(getSkillAcquisitionProgramList(searchObj, patientId, domainId));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.save_copyPatientSkillAcquisitionProgram.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_copyPatientSkillAcquisitionProgram', error);
            });
    };
};


export const getPatientSkillAcquisitionProgramSingleGraph = (patientId, skillAcquisitionProgramId, FromDate, ToDate, graphType) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_getPatientSkillAcquisitionProgramSingleGraph.REQUEST));
        fetch(`${GET_GETPATIENTSKILLACQUISITIONPROGRAMSINGLEGRAPH_API}?patientId=${patientId}&skillAcquisitionProgramId=${skillAcquisitionProgramId}&fromDate=${FromDate}&toDate=${ToDate}&graphType=${graphType}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_getPatientSkillAcquisitionProgramSingleGraph.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionProgramActionTypes.get_getPatientSkillAcquisitionProgramSingleGraph.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_getPatientSkillAcquisitionProgramSingleGraph', error);
            });
    };
  };


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/actions/skillAquisitionProgramActions.js